import {getCookie} from "./cookie"

// Проверяем
if (!process.env.REACT_APP_DOMAIN_API) throw Error("Error not find REACT_APP_DOMAIN_API")
// Домен для api
export const DOMAIN_API = process.env.REACT_APP_DOMAIN_API
// Название токена авторизации
export const TOKEN = getCookie("crm_token_access")
